import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

/**
 * Preserve Personal Map snowflake IDs that exceed Number.MAX_SAFE_INTEGER.
 */
function parsePersonalMapJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:locationId|sourceId|nextCursorLocationId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parsePersonalMapJson] };

function compactParams(params = {}) {
  const out = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value == null || value === '') return;
    if (typeof value === 'boolean') {
      out[key] = value;
      return;
    }
    out[key] = value;
  });
  return out;
}

/**
 * Owner Personal Map API（PM-1 endpoints only）。
 */
export const personalMapApi = {
  list: (params = {}, config = {}) => travelClient.get(
    travelEndpoints.myPersonalMap,
    { params: compactParams(params), ...snowflakeJson, ...config },
  ),

  hide: (locationId, config = {}) => travelClient.put(
    travelEndpoints.myPersonalMapHidden(locationId),
    null,
    { ...snowflakeJson, ...config },
  ),

  restore: (locationId, config = {}) => travelClient.delete(
    travelEndpoints.myPersonalMapHidden(locationId),
    { ...snowflakeJson, ...config },
  ),
};
